import { totalUnits } from '../../utils/inventoryMode';

// The PO lines the stock register has no record of, each with a tick, and the
// choice of one record per line or one per unit for the ticked ones.
//
// Used where a PO's goods are received (marking it delivered) and where a PO that
// was marked delivered without them is put right. A tick is a line whose goods
// belong in Inventory; a delivery charge or a service is left unticked.
export default function MissingStockPicker({ lines, selected, onToggle, mode, onMode }) {
  const chosen = lines.filter(l => selected.has(l.id));
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-3 py-1.5 border-b border-gray-200">
        <span className="text-[8px] font-bold uppercase text-gray-500">Lines with no stock record</span>
      </div>
      <div className="max-h-[220px] overflow-y-auto overflow-x-auto">
        <table className="w-full">
          <tbody>
            {lines.map(line => (
              <tr
                key={line.id}
                className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
                onClick={() => onToggle(line.id)}
              >
                <td className="px-3 py-2 w-8">
                  <input type="checkbox" readOnly checked={selected.has(line.id)} className="pointer-events-none" />
                </td>
                <td className="px-3 py-2 text-[10px]">
                  {line.description}
                  {line.line_type === 'service' && <span className="ml-1.5 text-[8px] text-gray-400">service</span>}
                </td>
                <td className="px-3 py-2 text-[9px] font-mono text-gray-400">{line.part_number || ''}</td>
                <td className="px-3 py-2 text-[9px] text-gray-500 text-right w-16">Qty {line.quantity ?? 1}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {chosen.length > 0 && (
        <div className="flex flex-wrap gap-x-5 gap-y-1 px-3 py-2 border-t border-gray-200 bg-gray-50">
          {[
            { value: 'batch', label: `One record per line (${chosen.length})`, hint: 'consumables, cables, anything not tracked unit by unit' },
            { value: 'individual', label: `One record per unit (${totalUnits(chosen)})`, hint: 'serialised kit with its own asset tag' },
          ].map(opt => (
            <label key={opt.value} className="flex items-start gap-1.5 cursor-pointer">
              <input type="radio" name="missing_stock_mode" value={opt.value} checked={mode === opt.value}
                onChange={() => onMode(opt.value)} className="mt-0.5 accent-navy" />
              <span>
                <span className="block text-[9px] font-semibold text-gray-800">{opt.label}</span>
                <span className="block text-[8px] text-gray-500">{opt.hint}</span>
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
